// removed by extract-text-webpack-plugin
module.exports = {"container":"_3X7Ri","emptyStates":"_2Coyi"};


//////////////////
// WEBPACK FOOTER
// ./app/components/restriction/restriction.scss
// module id = 1548
// module chunks = 0